import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface IpBlockFormState {
  ip: string
  status: 'active' | 'inactive'
}

export const ipBlockFields: (keyof IpBlockFormState)[] = ['ip', 'status']

interface IpBlockFieldsConfig extends FieldConfig<{
  ip: FieldRules<IpBlockFormState['ip']>
  status: FieldRules<IpBlockFormState['status']>
}> {}

interface IpBlockFieldsConfigProps extends FieldRulesConfig<IpBlockFormState> {}

export function ipBlockFieldsConfig(_props: IpBlockFieldsConfigProps): IpBlockFieldsConfig {
  return {
    fields: {
      ip: {
        rules: {
          required: 'IP Address is required',
          pattern: {
            value: /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
            message: 'Invalid IP address format',
          },
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
    },
  }
}
